module.exports = __webpack_public_path__ + "d57beb434656a0bf9dbddd223fab14fc.png";